export default function NewTabIcon({className = ''}: {className?: string}) {
    return (
        <svg className={className} height="1.25em" width="1.25em" fill="currentColor" viewBox="0 -960 960 960" >
            <path d="M160-160v-640h289.23v40H200v560h560v-249.23h40V-160H160Zm229.54-201.23-28.31-28.31L731.69-760H560v-40h240v240h-40v-171.69L389.54-361.23Z"/>
        </svg>
    )
}